// extracted by mini-css-extract-plugin
export default {"ffButton":"_button_ffButton__VGeFd","ff-button":"_button_ff-button__PH1D+","sm":"_button_sm__dKK2l","med":"_button_med__k7ddY"};